import "./App.css";
import Router from "./Components/Router";

import "./Styles/style.css";
import "./Styles/responsive.css";
import "./Styles/widgets.css";

// Dashboard Styles
import "./Styles/Styles/Responsive.css";

function App() {
    return (
        <div className="App position-relative">
            <Router />
        </div>
    );
}

export default App;
